import { adminDashboardRouteConfig } from './routes/AdminDashboardRoutes';
import { avonPatientRouteConfig } from './routes/AvonPatientRoutes';
import { callsPageRouteConfig } from './routes/CallsPageRoutes';
import { docketRouteConfig } from './routes/DocketRoutes';
import { enrollmentRouteConfig } from './routes/EnrollmentRoutes';
import { guideListPageRouteConfig } from './routes/GuideListRoutes';
import { hospitalizationRouteConfig } from './routes/HospitalizationRoutes';
import { loginPageRouteConfig } from './routes/LoginRoutes';
import { memberListRouteConfig } from './routes/MemberListRoutes';
import { memberPageRouteConfig } from './routes/MemberPageRoutes';
import { noAccessPageRouteConfig } from './routes/NoAccessRoutes';
import { trainingAdminPageRouteConfig } from './routes/TrainingAdminRoutes';
import { tvDashboardRouteConfig } from './routes/TvDashboardRoutes';

export const useAppNavigation = () => ({
  ...docketRouteConfig.useNavigationHooks(),
  ...memberListRouteConfig.useNavigationHooks(),
  ...enrollmentRouteConfig.useNavigationHooks(),
  ...memberPageRouteConfig.useNavigationHooks(),
  ...callsPageRouteConfig.useNavigationHooks(),
  ...guideListPageRouteConfig.useNavigationHooks(),
  ...trainingAdminPageRouteConfig.useNavigationHooks(),
  ...loginPageRouteConfig.useNavigationHooks(),
  ...avonPatientRouteConfig.useNavigationHooks(),
  ...adminDashboardRouteConfig.useNavigationHooks(),
  ...hospitalizationRouteConfig.useNavigationHooks(),
  ...noAccessPageRouteConfig.useNavigationHooks(),
  ...tvDashboardRouteConfig.useNavigationHooks(),
});
